import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            w: '100%',
            maxW: remCalc(1400),
            px: {base: remCalc(24), '2xl': 0},
            pb: remCalc(40),
            mx: 'auto',
        },
        '.dln-breadcrumbs ol, .dln-breadcrumbs ul': {
            display: 'block',
            height: remCalc(24),
            listStyle: 'none',
            textStyle: 'body-xsmall',
            my: {base: 'xsmall.base', lg: 'xsmall.md'},
        },
        '.dln-breadcrumbs__li': {
            display: 'inline-block',
            a: {
                color: 'text.secondary',
                lineHeight: remCalc(24),
                '&:after': {
                    content: '""',
                    display: 'inline-block',
                    borderWidth: remCalc(0.5),
                    borderBottom: 'small',
                    borderStyle: 'solid',
                    borderColor: 'border.light',
                    width: remCalc(26),
                    transform: 'rotate(-59deg)',
                },
            },
            'a:hover': {
                textDecoration: 'underline',
            },
            span: {
                lineHeight: remCalc(24),
                color: 'text.default',
            },
        },
        '.dln-terms .dln-breadcrumbs': {
            margin: '40px 0 0',
        },
        '.dln-terms__note': {
            fontSize: '13px',
            lineHeight: '125%',
        },
        '.dln-terms__head': {
            textStyle: {base: 'head-medium', lg: 'head-xlarge'},
            fontWeight: 500,
            width: '100%',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            paddingY: remCalc(24),
            marginBottom: {base: remCalc(24), lg: remCalc(40)},
            'h1, strong': {
                fontWeight: 'inherit',
                textAlign: 'left !important',
            },
        },
        '.dln-terms .dln-title': {
            margin: 0,
        },
        '.dln-terms .dln-btn': {
            maxWidth: '280px',
        },
        '.dln-terms__paragraph': {
            fontSize: '13px',
            lineHeight: '125%',
            margin: '0 0 16px',
        },
        '.dln-terms__paragraph:last-of-type': {
            margin: 0,
        },
        '.dln-terms__block': {
            width: '100%',
            margin: '32px 0 0',
            lineHeight: '150%',
        },
        '.dln-terms__block .dln-terms__paragraph:last-of-type': {
            margin: 0,
        },
        '.dln-terms__block ol, .dln-terms__block ul': {
            WebkitPaddingStart: '26px',
            paddingInlineStart: '26px',
            WebkitMarginAfter: '1em',
            marginBlockEnd: '1em',
        },
        '.dln-terms__block li': {
            lineHeight: '150%',
            listStylePosition: 'inside',
        },
        '.dln-terms__block p': {
            WebkitMarginBefore: '1em',
            marginBlockStart: '1em',
            WebkitMarginAfter: '1em',
            marginBlockEnd: '1em',
        },
        '.dln-terms__block h2': {
            fontSize: '1.375rem',
            lineHeight: '125%',
        },
        '.dln-terms__block h3': {
            fontSize: '1.125rem',
            lineHeight: '200%',
        },
        '.dln-terms__block h4': {
            margin: '0 0 16px',
        },
        '.dln-terms__block table, .dln-terms__block td, .dln-terms__block th': {
            border: '1px solid var(--ui-04)',
            textAlign: 'left',
            padding: '8px',
            borderCollapse: 'collapse',
        },
        '.dln-terms__block li a, .dln-terms__block p a, .dln-terms__block td a': {
            color: 'inherit',
        },
        '.dln-terms__subTitle': {
            fontSize: ['22px', '18px'],
            lineHeight: '125%',
            fontFamily: 'var(--fontNameBold)',
            fontWeight: 700,
            fontStyle: 'normal',
            margin: '0 0 16px',
        },
        '@media only screen and (max-width:599px)': {
            '.dln-terms__content': {
                width: '100%',
                maxWidth: '100%',
                margin: '0 0 100px',
            },
            '.dln-terms__subTitle': {
                fontSize: '15px',
            },
            '.dln-terms__block': {
                margin: '24px 0 0',
            },
            '.dln-delonghi .dln-terms--delonghi .dln-wrapper': {
                margin: '0',
                padding: '0 20px',
            },
            '.dln-delonghi .dln-terms--delonghi .dln-wrapper .dln-title--delonghi': {
                fontSize: '37px',
                fontFamily: 'var(--fontNameDelonghi)',
                fontWeight: 500,
                fontStyle: 'normal',
            },
            '.dln-delonghi .dln-terms--delonghi .dln-terms__head': {
                paddingLeft: '0',
                maxWidth: '100%',
            },
            '.dln-delonghi .dln-terms--delonghi .dln-terms__content': {
                maxWidth: '100%',
            },
        },
        '.dln-kenwood .dln-terms .dln-breadcrumbs a': {
            textDecoration: 'none',
        },
        '.dln-kenwood .dln-terms .dln-breadcrumbs a:hover': {
            textDecoration: 'underline',
        },
        '.dln-kenwood .dln-terms__content': {
            marginBottom: '70px',
            maxWidth: '100%',
        },
        '.dln-kenwood .dln-terms__head': {
            textAlign: 'center',
        },
        '.dln-kenwood .dln-terms__head .dln-title': {
            paddingBottom: '15px',
        },
        '.dln-kenwood .dln-terms__note': {
            fontFamily: 'var(--fontNameLight)',
            fontWeight: 300,
            fontStyle: 'normal',
            fontSize: '14px',
            lineHeight: '20px',
        },
        '.dln-kenwood .dln-terms__block': {
            marginTop: '40px',
        },
        '.dln-kenwood .dln-terms__subTitle': {
            fontFamily: 'var(--fontNameSemibold)',
            fontWeight: 600,
            fontStyle: 'normal',
            fontSize: '20px',
            lineHeight: '24px',
            marginBottom: '10px',
        },
        '.dln-kenwood .dln-terms__paragraph': {
            fontFamily: 'var(--fontNameLight)',
            fontWeight: 300,
            fontStyle: 'normal',
            fontSize: '14px',
            lineHeight: '20px',
        },
        '.dln-delonghi .dln-terms__content, .dln-delonghi .dln-terms__head': {
            maxWidth: '80%',
            margin: '0 auto',
        },
        '.dln-delonghi .dln-terms__note': {
            fontSize: '1rem',
            lineHeight: 1.5,
        },
        '.dln-delonghi .dln-terms__content': {
            marginBottom: '90px',
        },
        '.dln-delonghi .dln-terms__subTitle': {
            fontWeight: 500,
            fontStyle: 'normal',
            fontSize: '1.125rem',
            lineHeight: 1.07,
        },
        '.dln-delonghi .dln-terms__paragraph': {
            fontSize: '.875rem',
            lineHeight: 1.3,
        },
        '.dln-delonghi .dln-terms .dln-title--delonghi': {
            fontSize: '3.125rem',
            fontFamily: 'var(--fontNameDelonghi)',
            fontWeight: 500,
            fontStyle: 'normal',
        },
    },
}
